<template>
  <v-dialog v-model="show">
    <v-card class="search_dialog">
      <v-card-title>
        <h1>Song Search{{serviceName ? ' on ' + serviceName : ''}}</h1>
      </v-card-title>
      <v-card-text>
        <v-text-field ref="title" label='Title' v-model="title" autofocus></v-text-field>
        <v-text-field ref="artist" label='Artist' v-model="artist"></v-text-field>
        <div class="url">{{getSearchUrl(this.options)}}</div>
        <v-btn block :disabled="title.length===0" @click="onSearch">Search</v-btn>

        <v-list :two-line="isTwoLine">

          <v-subheader v-if="searching">Searching</v-subheader>
          <v-subheader v-else-if="searchResults.length===0">No Results</v-subheader>
          <v-subheader v-else="">Search Results</v-subheader>

          <template v-for="(result,i) in searchResults">
            <v-list-tile @click="onGetPage(result.tab_url, {title:result.song_name, artist:result.artist_name})">
              <v-list-tile-title>
                {{result.song_name}} <span class="artist">({{result.artist_name}})</span>
              </v-list-tile-title>
              <v-list-tile-sub-title v-if="result.votes || result.rating">
              </v-list-tile-sub-title>
              
              <div v-if="hasVotes" style="display: flex">
                <v-chip color="green" text-color="white">
                  <v-avatar class="green darken-4">{{result.votes}}</v-avatar>
                  Votes
                </v-chip>

                <v-chip color="green" text-color="white">
                  <v-avatar class="green darken-4">{{result.rating}}</v-avatar>
                  Rating
                </v-chip>
              </div>
              <div v-else style="font-size:.8em;float: right; white-space: nowrap">(click to import)</div>
              
            </v-list-tile>
            <v-divider></v-divider>
          </template>
        </v-list>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: "SongSearch",
    data: function () {
      return {
        show: false,

        searchResults: [],
        title: '',
        artist: '',
        searching: false,
        isTwoLine: false,
        serviceName: ''
      }
    },
    props: {},
    methods: {
      onSearch() {
        if (this.searching) {
          return
        }
        this.searching = true
        this.searchResults = []
        this.getSearchItems(this.options)
          .then(items => {
            this.searching = false
            this.searchResults = items
          })
          .catch(reason => {
            this.searching = false
            throw reason
          })
      },
      onGetPage(url, options) {
        this.getDocument(url, options).then(qcDoc => {
          this.$emit('input', qcDoc)
          this.show = false
          this.resolve(qcDoc)
        })
      },
      pickFile(opts = {}) {
        this.show = true
        this.title = opts.title || ''
        this.artist = opts.artist || ''

        this.$nextTick(() => {
          try {
            this.$refs.title.focus()
            if (opts.autoSubmit) {
              this.onSearch()
            }
          } catch (e) {
          }
        })
        return new Promise((resolve, reject) => {
          this.resolve = resolve
          this.reject = reject
        });
      },

      //
      // abstract methods
      //
      getSearchUrl(options) {
        throw 'getSearchUrl must be overridden'
      },
      getSearchItems(options) {
        return new Promise((resolve, reject) => {
          reject('getSearchItems must be overridden')
        });
      },
      getDocument(url, options) {
        return new Promise((resolve, reject) => {
          reject('getDocument must be overridden')
        });
      },
    },
    computed: {
      options() {
        return {title: this.title, artist: this.artist}
      },
      hasVotes() {
        return this.searchResults.length > 0 && this.searchResults[0].hasOwnProperty('votes')
      },
    }
  }
</script>

<style>
  .search_dialog .url {
    font-size: .9em;
    color: grey;
  }

  .search_dialog .artist {
    font-size: .9em;
    color: grey;
  }
</style>